import type { RouteRecordRaw } from 'vue-router'

export const errorRoutes: RouteRecordRaw[] = [
  {
    path: '/access-denied',
    name: 'forbidden',
    component: () => import('./pages/Error403Page.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('./pages/Error404Page.vue'),
    meta: { requiresAuth: false }
  }
]

/**
 * Routes that should render inside the authenticated DashboardLayout
 * (sidebar + header preserved).
 */
export const dashboardErrorRoutes: RouteRecordRaw[] = [
  {
    path: '/coming-soon',
    name: 'coming-soon',
    component: () => import('./pages/ComingSoonPage.vue')
  }
]
